import { useRef } from "react";
import { Button, Row, Col } from "react-bootstrap";
import SignatureCanvas from "react-signature-canvas";
import { FormattedMessage } from "react-intl";
import { toast } from "react-toastify";

const SignaturePad = ({
  signature,
  setSignature,
  admissionID,
  error,
  setFormData,
  // center_uuid,
}) => {
  // console.log(signature);
  const API_URL = process.env.REACT_APP_API_URL;
  // const PORTAL_URL = process.env.REACT_APP_PORTAL_URL;

  const signaturePadRef = useRef();
  // const [isSigned, setIsSigned] = useState(false);

  // User draws signature
  const handleSignature = () => {
    // setIsSigned(true);
    const base64 = signaturePadRef.current.getCanvas().toDataURL("image/png");
    setSignature(base64);
  };

  // Clear: Renew signature
  const handleClear = () => {
    if (signaturePadRef.current) {
      signaturePadRef.current.clear();
    }
    // setIsSigned(false);
    setSignature(null);
  };

  // Delete: Remove from DB
  const handleDelete = async () => {
    try {
      const fD = new FormData();
      fD.append("field_name", "signature");
      fD.append("table_name", "admission_extra_info");
      fD.append("admission_id", admissionID);
      const response = await fetch(`${API_URL}/delete-doc?tenant_id=f47ac10b58cc4372a5670e029j198745`, {
        method: "POST",
        body: fD,
      });
      if (response.ok) {
        setSignature(null);
        setFormData((prev) => ({
          ...prev,
          signature: null,
        }));
        toast.success(<FormattedMessage id="validation.file_deleted" />);
      }
    } catch (error) {
      // error handling
    }
  };

  return (
    <>
      <Row className="mb-4">
        <Col md={12}>
          <FormattedMessage id="signature" />

          {/* Show preview and delete if uploaded */}
          {signature && typeof signature === "object" && signature.preview ? (
            <div style={{ marginBottom: 10 }}>
              <img
                src={signature.preview}
                alt="Signature Preview"
                style={{
                  border: "1px solid #ccc",
                  maxWidth: 400,
                  maxHeight: 150,
                }}
              />
              <div className="mt-2">
                <Button variant="danger" size="sm" onClick={handleDelete}>
                  Delete
                </Button>
              </div>
            </div>
          ) : (
            <div
              style={{
                border: "1px solid #ccc",
                borderRadius: 8,
                width: 400,
                height: 150,
              }}
            >
              <SignatureCanvas
                ref={signaturePadRef}
                penColor="black"
                canvasProps={{
                  width: 400,
                  height: 150,
                  className: "sigCanvas",
                }}
                onEnd={handleSignature}
              />

              <div className="mt-2">
                {error && (
                  <small className="text-danger mt-1" style={{ fontSize: 12 }}>
                    <FormattedMessage id="error.signature" />
                  </small>
                )}
              </div>
              <div className="mt-2">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={handleClear}
                >
                  Clear
                </Button>
              </div>
            </div>
          )}
        </Col>
      </Row>
    </>
  );
};

export default SignaturePad;
